import { DsChart } from './ds-chart.class';
import { ChartOptions } from 'chart.js';
import { DsChartInterface } from '../interfaces/ds-chart.interface';
import {
  getNewTimeXAxis,
  getNewYAxis,
  getTooltipYLabelCallback,
  getDateTooltipLabelCallback,
  getElements,
} from '../functions/ds-charts.functions';
import { DsChartCustomOptions } from '../interfaces/ds-chart-custom-options.interface';

export class DsLineChart extends DsChart {
  /**
   * Creates an instance of DsLineChart.
   *
   * @param language the current language
   * @memberof DsLineChart
   */
  constructor(language = 'en') {
    super(language);
    // Default chart type is set, but it can be overridden by chart object.
    this.chartType = 'line';
  }

  /**
   * Overload of base class function. Init chart for line time chart.
   *
   * @param chart the current chart
   */
  public initChart(chart: DsChartInterface) {
    const options = this.getTimeChartOptions(chart.customOptions);
    chart.options = options;
    super.initChart(chart);
  }

  /**
   * Get chart options for time chart.
   *
   * @param customOptions Custom options for chart
   * @returns ChartOptions
   */
  private getTimeChartOptions(customOptions: DsChartCustomOptions = {}): ChartOptions {
    const options: ChartOptions = this.getMergedOptions(customOptions);
    options.elements = getElements(customOptions.fill, customOptions.tension);
    options.scales.xAxes = [getNewTimeXAxis(customOptions)];
    options.scales.yAxes = [getNewYAxis(customOptions, true)];

    options.tooltips = {
      callbacks: {
        title: getDateTooltipLabelCallback(customOptions.tooltipDateFormat),
        label: getTooltipYLabelCallback(),
      },
    };
    return options;
  }
}
